import { z } from 'zod';
import { RecordMeetingResultSchema } from './record-meeting-result';

export const STTJobSchema = z.object({
  recordMeetingResult: RecordMeetingResultSchema.optional()
});

export type STTJob = z.infer<typeof STTJobSchema>;
